import { fns } from "@/core/utils/date-fns";
import { eff } from "@/core/utils/effect-ts-abbr";
import { Prop, Vue } from "vue-property-decorator";

export class AppFormatDateComponent extends Vue {
    @Prop({ required: true })
    value!: Date | number;

    @Prop({ default: "dd/MM/yyyy" })
    format!: string;

    get formattedValue() {
        return eff.fn.pipe(this.value, fns.format(this.format));
    }
}
